import { Injectable } from '@angular/core';
import { createAction, props } from '@ngrx/store';

Injectable({
    providedIn: 'root'
})
export class AppointmentSettingsActions {

    // TODO: if we are saving in Users usercustomfieldjson, should we get it from CurrentUser instead?
    static getAppointmentSettings =
        createAction('[Reminders:Appointment:Settings] Get Appointment Settings', props<{ userId: number }>());

    static getAppointmentSettingsSuccess = createAction('[Reminders:Appointment:Settings] Get Appointment Settings Success'
        , props<{ displayTwoway: boolean, displayBirthday: boolean, displayIncorrectDestinator: boolean, showProviders: boolean }>());

    static saveAppointmentSettings = createAction('[Reminders:Appointments:Settings] Save Appointment Settings',
        props<{ displayTwoway: boolean, displayBirthday: boolean, displayIncorrectDestinator: boolean, showProviders: boolean }>());

    static saveAppointmentSettingsSuccess = createAction('[Reminders:Appointment:Settings] Save Appointment Settings Success'
        , props<{ displayTwoway: boolean, displayBirthday: boolean, displayIncorrectDestinator: boolean, showProviders: boolean }>());

    static saveAppointmentSettingsFail = createAction('[Reminders:Appointment:Settings] Save Appointment Settings Failed'
        , props<{ error: any }>());

}
